import { MotionDiv } from '@/components/element/MotionDiv';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { useMemo } from 'react';

export const ContractAlert = () => {
  const { _po_ } = useCurrentPurchaseOrder();

  const showAlert = useMemo(
    () => ['contracting', 'completed'].includes(_po_!.team_purchase_order_phase.name) && !_po_!.closed,
    [_po_]
  );

  if (showAlert) {
    return (
      <MotionDiv className="alert alert-warning text-white">
        <span className="alert-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </span>
        <span className="alert-text text-sm">このプロジェクトは承認された契約タスクが存在しません。</span>
      </MotionDiv>
    );
  } else {
    return null;
  }
};
